import {axiosInstance} from '../helper/appclient'
import get from 'lodash/get'
import {LOGIN_URL, SAMPLE_URL} from '../config/url-config'

import {
    ERR_MSG,
    LOG_ERR_101,
    LOG_ERR_102,
    LOG_ERR_103,
    LOG_ERR_104, LOG_ERR_105, LOG_ERR_106, LOG_ERR_107, LOGIN_ATTEMPT_ERR, LOGIN_CRED_ERR,
    SESS_EXPIRED_TEXT,
    SUCCESS_CODES, TEMP_PASS_EXPIRED, UNK_ERR_102
} from "../constants/constants";
import {store} from '../store/store'
import {loadSession, loadSessionExpired} from "../store/action";
import {extractStatusCode} from "../helper/responsehelper";

export const loginStatus = {
    [LOG_ERR_101]: TEMP_PASS_EXPIRED,
    [LOG_ERR_102]:LOGIN_CRED_ERR,
    [UNK_ERR_102]: ERR_MSG,
    [LOG_ERR_103]: ERR_MSG,
    [LOG_ERR_104]: ERR_MSG,
    [LOG_ERR_105]: LOGIN_CRED_ERR,
    [LOG_ERR_106]: LOGIN_ATTEMPT_ERR,
    [LOG_ERR_107]:ERR_MSG,

};

const constructLoginRequest = (userName,password)=>(
    {
        username: userName,
        password: password,
    }
)
export const loginService = (userName,password)=>{
    const loginRequest = constructLoginRequest(userName,password)
    return new Promise((resolve,reject)=>{
        axiosInstance
            .post(LOGIN_URL(),loginRequest)
            .then((response) => {
                let statusCode =extractStatusCode(response);
                console.log("statusCode",statusCode)
                let serviceResponseBody = get(response,"serviceResponseBody");
                let session = get(serviceResponseBody,"session");
                // axiosInstance.post(SAMPLE_URL())
                //     .then((response1)=>{
                //         console.log("response",response1)
                //     })
                if(SUCCESS_CODES.LOGIN.includes(statusCode)){
                    store.dispatch(loadSession(session))
                    resolve(response)
                }else{
                    let errText = loginStatus[statusCode]
                    console.log("errText",errText)
                    if(errText === SESS_EXPIRED_TEXT){
                        store.dispatch(loadSessionExpired(true))
                    }
                    reject(errText || ERR_MSG )
                }
            })
            .catch((error) => {
                console.log(error)
                reject(ERR_MSG)
            });
    })
}